import React from 'react'
import 'styled-components/macro'
import './App.css'
import './Record.css'
import './Relation.css'
import { BrowserRouter, Route, Link } from 'react-router-dom'
import { AuthProvider } from './AuthContext'
import { Organizations } from './Organizations'
import People from './People'
import NavBar from './components/NavBar'
import Users from './components/Users'

const Main = () => {
  return <div className="home">
    <h1>People</h1>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </p>
    <div css="text-align: right">
      <Link className="link" to="/people">see list &gt;&gt;</Link>
    </div>
    <h1>Organizations</h1>
    <p>
      Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
    </p>
    <div css="text-align: right">
      <Link className="link" to="/organizations">see list &gt;&gt;</Link>
    </div>
  </div>
}

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="screen">
          <NavBar />
          <div className="main">
            <Route path="/" exact component={Main} />
            <Route path="/people" exact component={People} />
            <Route path="/people/:personId" component={People} />
            <Route path="/organizations" exact component={Organizations} />
            <Route path="/organizations/:organizationId" component={Organizations} />
            <Route path="/users" component={Users} />
          </div>
          <div className="footer">created by, copyrighted, 2020</div>
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App